import http from 'conversations-http/clients/http';
export const sendOfflineNotice = () => http.put('messages/v2/presence/offline');